import { DOMAIN, IS_TRIAL_DEMO } from '@meego/biz-constants';
import { defaultConfig } from './config.default';
import { externalTenantConfig } from './config.external';

const config = /*#__PURE__*/ (() => ({
  ...defaultConfig,

  region: 'boe',
  avatarDomain: 'https://project.feishu-boe.cn/goapi',
  host: `https://${DOMAIN.BOE_EXTERNAL}`,
  hostForGo: 'https://project.feishu-boe.cn/goapi',
  collectHost: 'https://dahdpa2y.fn-boe.bytedance.net',

  guideLink: 'https://bytedance.feishu.cn/docs/doccnXOiqRbhTCZ7OxC1uKdAYfe',
  currentHost: `https://${DOMAIN.BOE_EXTERNAL}`,
  tosBucket: 'meego-business-boe',
  larkLoginHost: 'https://www.feishu-boe.cn',
  tenantConfig: externalTenantConfig,
  labProjectId: '62217bfa6e5c01f61d1915fb', // todo
  labViewId: '6t8fncLnR', // todo
  TeaConfig: {
    ...defaultConfig.TeaConfig,
    ...(IS_TRIAL_DEMO ? { report_url: 'https://project.feishu-boe.cn/goapi/v1/event/record' } : {}),
  },
  externalHiddenFields: [
    'need_ab',
    'ab_test_status_draft',
    'ab_test_status_design',
    'ab_test_status_opened',
    'ab_test_status_code_offline',
    'legal',
    'legal_status',
    'legal_complete',
    'enable_sdlc',
    'sdlc_complete',
  ],
  externalHiddenControls: [
    'platform_legal_status',
    'platform_sdlc_status',
    'platform_ee_security_status',
    'online_ticket',
    'platform_libra_ab_list',
    'platform_starling_status',
    'platform_cony_mr_list',
    'platform_devops',
    'gitlab_branch',
    'repos',
    'platform_zeus_feedback_amount',
    'platform_zeus_feedback_percent',
    'platform_test_case',
    'platform_bytecycle_change_item',
    'platform_aeolus_report',
  ],
  calculationFieldHelpDoc: 'https://bytedance.feishu.cn/docs/doccnERNgCyeD0XFMTycDAEQg5g',
  showTenantIds: [],
  helpcenterUrl: `https://${DOMAIN.BOE_EXTERNAL}/helpcenter/home`,
}))();

export default config;
